/*
  Speakyti fix (2026-10-13): close the mobile menu drawer when a menu link points
  to an anchor on the CURRENT page (e.g. "How it works" -> /#speakyti-how-it-works,
  "FAQ" -> /#common-questions while on the homepage). Dawn only closes the drawer
  on page navigation, so same-page anchor links left the menu stuck open with the
  page scroll locked. Kept in a Speakyti file (not Dawn's global.js) so Shopify
  theme updates don't overwrite it. Loaded from sections/speakyti-footer.liquid.
*/
(function () {
  if (window.__spkMenuAnchorFix) return;
  window.__spkMenuAnchorFix = true;
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('header-drawer a[href*="#"]');
    if (!link) return;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (e) { return; }
    if (!url.hash || url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
    var drawer = link.closest('header-drawer');
    var summary = drawer && drawer.querySelector('details > summary');
    if (summary && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event, summary);
  });
})();

/*
  V11.5 (2026-11-01): the Shopify Forms "10% off" side tab goes away after the
  visitor's first click anywhere on the site (menu, buttons, links...), and stays
  gone for the rest of the visit (this browser tab's session). Clicks on the
  popup or the tab itself don't count. Hidden via the html.spk-teaser-off class;
  the CSS rule is in assets/speakyti-cart-upsell.css.
*/
(function () {
  if (window.__spkTeaserOff) return;
  window.__spkTeaserOff = true;
  var KEY = 'spk_teaser_off';
  var root = document.documentElement;
  function hide() { root.classList.add('spk-teaser-off'); }
  try { if (window.sessionStorage.getItem(KEY)) hide(); } catch (e) {}
  document.addEventListener('click', function (event) {
    if (root.classList.contains('spk-teaser-off')) return;
    var t = event.target;
    if (t && t.closest && t.closest('shopify-forms-embed')) return;
    var path = event.composedPath ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      if (path[i] && path[i].tagName && path[i].tagName.toLowerCase() === 'shopify-forms-embed') return;
    }
    hide();
    try { window.sessionStorage.setItem(KEY, '1'); } catch (e) {}
  }, true);
})();
